import { useEffect } from 'react';

type LayerWithDefaultVisibility = {
  id: string;
  defaultVisible?: boolean | null;
};

type UseDefaultLayerVisibilityByIdParams = {
  layers: LayerWithDefaultVisibility[];
  setVisibilityById: React.Dispatch<
    React.SetStateAction<Map<string, boolean | null>>
  >;
};

/**
 * Initialize internal and external layer default visibility, using db column
 * when available.
 */
export function useDefaultLayerVisibilityById({
  layers,
  setVisibilityById,
}: UseDefaultLayerVisibilityByIdParams) {
  useEffect(() => {
    setVisibilityById((prev) => {
      const next = new Map(prev);
      let hasChanges = false;

      for (const layer of layers) {
        const layerId = String(layer.id);
        if (!next.has(layerId)) {
          next.set(layerId, layer.defaultVisible ?? false);
          hasChanges = true;
        }
      }

      return hasChanges ? next : prev;
    });
  }, [layers, setVisibilityById]);
}
